import axios, { Axios } from "axios";
import { json } from "react-router-dom";
import axiosInstance from "src/hooks/axios-interceptor";





//ASSET

export const CreateContract = (body) => {
  

  return axiosInstance
    .post(`/contract/createNewContractForAssets/${body.asset}`, body)
    .then((response) => {
     
      return response.data.response[0];
    })
    .catch((error) => {
      var response = catchAxiosError(error);
       return response;
    });
};


export const CreateCompany = (body) => {
  

  return axiosInstance
    .post(`/mntCompany/createNewMaintenanceCompany`, body)
    .then((response) => {
     
      return response.data.response[0];
    })
    .catch((error) => {
      var response = catchAxiosError(error);
       return response;
    });
};

export const UpdateCompany = (body) => {
  return axiosInstance
    .put(`/mntCompany/updateMaintenanceCompany/${body.id}`, body, {
      headers: {
        'Content-Type': 'application/json', // Set the content type to JSON
      },
    })
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      var response = catchAxiosError(error);
      return response;
    });
};


export const UpdateContract = (body) => {
  

  // body.organization = { id: 1 };
  return axiosInstance
    .put(`/contract/${body.id}`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
       var response = catchAxiosError(error);
       return response;
    });
};



export const deleteContract = (id) => {
  return axiosInstance
    .delete(`/contract/deleteContract/${id}`)
    .then((response) => {
     
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const deleteMntOperator = (id) => {
  return axiosInstance
    .delete(`/mntOperator/deleteMntOperator/${id}`)
    .then((response) => {
     
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};



export const getContract = (id) => {
  

  return axiosInstance
    .get(`/contract/${id}`)
    .then((response) => {
     
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getAllContracts = () => {
  

  return axiosInstance
    .get(`/contract/getAllContracts`)
    .then((response) => {
      
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getAllCompanies = () => {
  

  return axiosInstance
    .get(`/mntCompany/getAllMaintenanceCompanies`)
    .then((response) => {
      
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const deleteCompany = (id) => {

  return axiosInstance
    .delete(`/mntCompany/deleteMaintenanceCompany/${id}`)
    .then((response) => {
      
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};


//private methods

const catchAxiosError = (error) => {
  if (!error.response) {
    // network error
    return json(
      {},
      {
        status: 404,
      }
    );
  } else {
    const code = error.response.status;
    const message = error.message;
    return { errors:[message]}
  }
};
